import React from 'react';
import { CustomerDecisionOptionsType, ProductItem, REJECT_ALTERNATIVE, WAIT_FOR_RESTOCK_OF_ORIGINAL_PRODUCT } from "./AlternativeOfferModal";
import * as translator from "../../../utils/translator";
import { useParams } from 'react-router-dom';

type Props = {
    onCustomerChoiceChange: (originalProductItemID: number, alternativeProductItemID: CustomerDecisionOptionsType) => void;
    originalProduct: ProductItem;
    treatAsMultipleProductsOrder: boolean;
}

export const NonAlternativeContainer: React.FC<Props> = ({
    onCustomerChoiceChange,
    originalProduct,
    treatAsMultipleProductsOrder,
}) => {

    const { country } = useParams() as {
        country: string;
    };

    const handleWait10Days = () => {
        onCustomerChoiceChange(originalProduct.product_item_id, WAIT_FOR_RESTOCK_OF_ORIGINAL_PRODUCT);
    };

    const handleCancelOrder = () => {
        onCustomerChoiceChange(originalProduct.product_item_id, REJECT_ALTERNATIVE);
    };


    return (
        <div className="non-alternative-container">
            {/* Product info row */}
            <div className="non-alternative-product-row">
                {/* Product image */}
                <div className="non-alternative-product-img-container">
                    <img
                        src={originalProduct.imageSrc}
                        alt={originalProduct.title}
                        className="non-alternative-product-img"
                    />
                </div>

                {/* Product details and actions */}
                <div className="non-alternative-product-details">
                    {/* Product title */}
                    <p className="non-alternative-product-title">
                        {originalProduct.titleView}
                    </p>

                    {/* Actions container */}
                    <div className="non-alternative-actions-container-desktop">
                        <button
                            className="non-alternative-action-button wait-action"
                            onClick={handleWait10Days}
                        >
                            {translator.translate(
                                translator.getLanguageByCountry(country),
                                "my_account",
                                "MyOrders/details/alternative_offer_modal/wait_10_days_button"
                            )}
                        </button>
                        <button
                            className="non-alternative-action-button cancel-action"
                            onClick={handleCancelOrder}
                        >
                            {treatAsMultipleProductsOrder
                                ? translator.translate(
                                    translator.getLanguageByCountry(country),
                                    "my_account",
                                    "MyOrders/details/alternative_offer_modal/cancel_order_button_multiple_products"
                                )
                                : translator.translate(
                                    translator.getLanguageByCountry(country),
                                    "my_account",
                                    "MyOrders/details/alternative_offer_modal/cancel_order_button_single_product"
                                )
                            }
                        </button>
                    </div>
                </div>

                {/* Mobile actions */}
                <>
                    <button
                        className="non-alternative-action-button wait-action-mobile"
                        onClick={handleWait10Days}
                    >
                        {translator.translate(
                            translator.getLanguageByCountry(country),
                            "my_account",
                            "MyOrders/details/alternative_offer_modal/wait_10_days_button"
                        )}
                    </button>
                    <button
                        className="non-alternative-action-button cancel-action-mobile"
                        onClick={handleCancelOrder}
                    >
                        {treatAsMultipleProductsOrder
                            ? translator.translate(
                                translator.getLanguageByCountry(country),
                                "my_account",
                                "MyOrders/details/alternative_offer_modal/cancel_order_button_multiple_products"
                            )
                            : translator.translate(
                                translator.getLanguageByCountry(country),
                                "my_account",
                                "MyOrders/details/alternative_offer_modal/cancel_order_button_single_product"
                            )
                        }
                    </button>
                </>
            </div>
        </div>
    );
};
